import React from 'react';
import { Auto } from 'fw/forms';
import * as API from 'modules/app/API'

class UserAuto extends React.PureComponent {

    usersLoader = () => {
        return {
            url: API.Security.url('/lookup/lookupUser'),
            params: {
                roles: this.props.roles,
                filter: this.props.filter,
                showUserTypeCode: this.props.showUserTypeCode
            }
        }
    }

    render() {
        return (
            <Auto {...this.props} loader={this.usersLoader} />
        )
    }
}

export default UserAuto;

// Mark this as a form component
UserAuto.defaultProps = {
    formControl: true,
    managed: false,
    roles: null,
    filter: null,
    showUserTypeCode: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/userAuto/UserAuto.js